<!-- BLOQUE 1: Hero con puzzle hexagonal -->
<app-hero-home></app-hero-home>

<!-- BLOQUE 2: Trust strip -->
<section class="trust" appReveal>
  <div class="trust__card">
    <span class="trust__label">SECTORES</span>
    <div class="trust__items">
      @for (s of sectores; track s; let last = $last) {
        <span class="trust__item">{{ s }}</span>
        @if (!last) {
          <span class="trust__sep">·</span>
        }
      }
    </div>
    <span class="trust__made">Hecho en Palma de Mallorca</span>
  </div>
</section>

<!-- BLOQUE 3: Módulos (grid de color) -->
<app-home-modulos appReveal></app-home-modulos>

<!-- BLOQUE 4: Precios -->
<app-home-precios appReveal></app-home-precios>

<!-- BLOQUE 5: Por qué nosotros (comparativa) -->
<app-por-que-nosotros appReveal></app-por-que-nosotros>

<!-- BLOQUE 6: Desarrollo a medida -->
<app-otros-servicios appReveal></app-otros-servicios>

<!-- BLOQUE 7: Confianza / testimonios -->
<app-clientes-proyectos appReveal></app-clientes-proyectos>

<!-- BLOQUE 8: CTA negra -->
<section class="cta-dark" appReveal>
  <div class="cta-dark__inner">
    <span class="cta-dark__hex" aria-hidden="true">
      <svg viewBox="0 0 100 100" width="320" height="340">
        <path
          d="M50 4 L93 27 L93 73 L50 96 L7 73 L7 27 Z"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linejoin="round" />
      </svg>
    </span>
    <div class="cta-dark__copy">
      <h2 class="cta-dark__title">
        Fichaje, facturación y tu gestión en un solo sitio. Desde 45 €/mes,
        fichen 10 o fichen 40.
      </h2>
      <p class="cta-dark__sub">
        Sin permanencia. Y si quieres que te lo dejemos montado, lo hacemos
        por ti — puesta en marcha opcional.
      </p>
      <div class="cta-dark__actions">
        <a
          routerLink="/prueba-sin-compromiso"
          class="cta-dark__btn cta-dark__btn--primary">
          Empieza la prueba
        </a>
        <a routerLink="/contacto" class="cta-dark__btn cta-dark__btn--ghost">
          Cuéntanos tu caso
        </a>
      </div>
    </div>
  </div>
</section>
